module.exports = __webpack_public_path__ + "static/logo-bageri-b77b3526fd0429944b2aa4a5581e20f7.svg";